"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// *** Version: 11 ***

function communLeatherGoodsFinish(slug) {
  return {
    name: 'Finition',
    items: [{
      name: 'Recollage (x1)',
      prices: {
        SIMPLE: 5
      },
      id: "11.".concat(slug, "-finish-1")
    }, {
      name: 'Finition supplémentaire - Simple',
      prices: {
        SIMPLE: 5
      },
      id: "11.".concat(slug, "-finish-2")
    }, {
      name: 'Finition supplémentaire - Standard',
      prices: {
        SIMPLE: 10
      },
      id: "11.".concat(slug, "-finish-3")
    }, {
      name: 'Finition supplémentaire - Complexe',
      prices: {
        SIMPLE: 20
      },
      id: "11.".concat(slug, "-finish-4")
    }, {
      name: 'Finition supplémentaire - Luxe',
      prices: {
        SIMPLE: 50
      },
      id: "11.".concat(slug, "-finish-5")
    }, {
      name: 'Ajustement sur-mesure (1h)',
      prices: {
        SIMPLE: 80
      },
      id: "11.".concat(slug, "-finish-6")
    }]
  };
}
function generateLeatherGoodsAccePrice(slug) {
  return {
    categories: [{
      name: 'Entretenir',
      items: [{
        name: 'Nettoyage & Soin complet',
        prices: {
          SIMPLE: 20,
          COMPLEX: 30
        },
        id: "11.".concat(slug, "-prevent-1")
      }, {
        name: 'Cirage simple',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: "11.".concat(slug, "-prevent-2")
      }, {
        name: 'Imperméabiliser',
        prices: {
          SIMPLE: 15,
          COMPLEX: 15
        },
        id: "11.".concat(slug, "-prevent-3")
      }, {
        name: 'Perçage de trou',
        prices: {
          SIMPLE: 3,
          COMPLEX: 3
        },
        id: "11.".concat(slug, "-prevent-4")
      }]
    }, {
      name: 'Recolorer',
      items: [{
        name: 'Recoloration - Accessoire',
        prices: {
          SIMPLE: 50
        },
        id: "11.".concat(slug, "-recolor-2")
      }]
    }, {
      name: 'Réparer',
      items: [{
        name: 'Zip - Changement simple',
        prices: {
          SIMPLE: 60
        },
        multiple: true,
        id: "11.".concat(slug, "-cure-1")
      }, {
        name: 'Zip - Changement simple fourni par le client',
        prices: {
          SIMPLE: 50
        },
        multiple: true,
        id: "11.".concat(slug, "-cure-2")
      }, {
        name: 'Zip - Changement standard',
        prices: {
          SIMPLE: 80
        },
        multiple: true,
        id: "11.".concat(slug, "-cure-3")
      }, {
        name: 'Zip - Changement standard fourni par le client',
        prices: {
          SIMPLE: 70
        },
        multiple: true,
        id: "11.".concat(slug, "-cure-4")
      }, {
        name: 'Zip - Changement complexe',
        prices: {
          SIMPLE: 100
        },
        multiple: true,
        id: "11.".concat(slug, "-cure-5")
      }, {
        name: 'Zip - Changement complexe fourni par le client',
        prices: {
          SIMPLE: 90
        },
        multiple: true,
        id: "11.".concat(slug, "-cure-6")
      }, {
        name: 'Curseur',
        prices: {
          SIMPLE: 15
        },
        id: "11.".concat(slug, "-cure-7")
      }, {
        name: 'Curseur fourni par le client',
        prices: {
          SIMPLE: 13
        },
        id: "11.".concat(slug, "-cure-8")
      }, {
        name: 'Tirette de curseur',
        prices: {
          SIMPLE: 5
        },
        id: "11.".concat(slug, "-cure-9")
      }, {
        name: 'Tirette de curseur fourni par le client',
        prices: {
          SIMPLE: 4
        },
        id: "11.".concat(slug, "-cure-10")
      }, {
        name: 'Boutons pression / rivet / oeillet',
        prices: {
          SIMPLE: 5
        },
        multiple: true,
        id: "11.".concat(slug, "-cure-11")
      }, {
        name: 'Boutons pression / rivet / oeillet fourni par le client',
        prices: {
          SIMPLE: 4
        },
        multiple: true,
        id: "11.".concat(slug, "-cure-12")
      }, {
        name: 'Fermoir - Changement simple',
        prices: {
          SIMPLE: 30
        },
        id: "11.".concat(slug, "-cure-13")
      }, {
        name: 'Fermoir - Changement simple fourni par le client',
        prices: {
          SIMPLE: 20
        },
        id: "11.".concat(slug, "-cure-14")
      }, {
        name: 'Fermoir - Changement complexe',
        prices: {
          SIMPLE: 50
        },
        id: "11.".concat(slug, "-cure-15")
      }, {
        name: 'Fermoir - Changement complexe fourni par le client',
        prices: {
          SIMPLE: 40
        },
        id: "11.".concat(slug, "-cure-16")
      }, {
        name: 'Crochet / boucle / autre pièce métallique - Changement',
        prices: {
          SIMPLE: 30
        },
        multiple: true,
        id: "11.".concat(slug, "-cure-17")
      }, {
        name: 'Crochet / boucle / autre pièce métallique fourni par le client - Changement',
        prices: {
          SIMPLE: 20
        },
        multiple: true,
        id: "11.".concat(slug, "-cure-18")
      }, {
        name: 'Déchirure : réparation avec pose d‘empiècement',
        prices: {
          SIMPLE: 60
        },
        multiple: true,
        id: "11.".concat(slug, "-cure-19")
      }, {
        name: 'Doublure - Changement',
        prices: {
          SIMPLE: 45
        },
        id: "11.".concat(slug, "-cure-20")
      }, {
        name: 'Bandoulière / anse / poignée / biais - Changement simple (x1)',
        prices: {
          SIMPLE: 40
        },
        id: "11.".concat(slug, "-cure-21")
      }, {
        name: 'Couture décousu',
        prices: {
          SIMPLE: 20
        },
        id: "11.".concat(slug, "-cure-22")
      }]
    }, communLeatherGoodsFinish(slug)]
  };
}

/* eslint max-len: 0, object-curly-newline: 0 */
var rawLeatherGoodsPricing = [{
  name: 'Sac',
  slug: 'bag',
  hasMostCommonCategory: false,
  showInPlugin: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }],
  categories: [{
    name: 'Entretenir',
    items: [{
      name: 'Nettoyage & Soin complet - Petit sac (< 25 cm)',
      prices: {
        SIMPLE: 40,
        COMPLEX: 60
      },
      id: '11.bag-prevent-1'
    }, {
      name: 'Nettoyage & Soin complet - Sac moyen (25 - 40 cm)',
      prices: {
        SIMPLE: 70,
        COMPLEX: 90
      },
      id: '11.bag-prevent-2'
    }, {
      name: 'Nettoyage & Soin complet - Grand sac (> 40 cm)',
      prices: {
        SIMPLE: 100,
        COMPLEX: 120
      },
      id: '11.bag-prevent-3'
    }, {
      name: 'Cirage simple - Sac',
      prices: {
        SIMPLE: 30,
        COMPLEX: 30
      },
      id: '11.bag-prevent-4'
    }, {
      name: 'Imperméabiliser',
      prices: {
        SIMPLE: 15,
        COMPLEX: 15
      },
      id: '11.bag-prevent-5'
    }]
  }, {
    name: 'Recolorer',
    items: [{
      name: 'Recoloration - Partielle (x1)',
      prices: {
        SIMPLE: 20
      },
      id: '11.bag-recolor-1'
    }, {
      name: 'Recoloration - Petit sac (< 25 cm)',
      prices: {
        SIMPLE: 100
      },
      id: '11.bag-recolor-2'
    }, {
      name: 'Recoloration - Sac moyen (25 - 40 cm)',
      prices: {
        SIMPLE: 175
      },
      id: '11.bag-recolor-3'
    }, {
      name: 'Recoloration - Grand sac (> 40 cm)',
      prices: {
        SIMPLE: 250
      },
      id: '11.bag-recolor-4'
    }]
  }, {
    name: 'Réparer',
    items: [{
      name: 'Craquelure / éraflure : raccord couleur',
      prices: {
        SIMPLE: 20
      },
      multiple: true,
      id: '11.bag-cure-1'
    }, {
      name: 'Craquelure / éraflure / petite déchirure : réparation',
      prices: {
        SIMPLE: 40
      },
      multiple: true,
      id: '11.bag-cure-2'
    }, {
      name: 'Déchirure : réparation avec pose d‘empiècement',
      prices: {
        SIMPLE: 60
      },
      multiple: true,
      id: '11.bag-cure-3'
    }, {
      name: 'Déchirure : réparation avec changement de panneau (petit)',
      prices: {
        SIMPLE: 90
      },
      multiple: true,
      id: '11.bag-cure-4'
    }, {
      name: 'Déchirure : réparation avec changement de panneau (moyen)',
      prices: {
        SIMPLE: 120
      },
      multiple: true,
      id: '11.bag-cure-5'
    }, {
      name: 'Déchirure : réparation avec changement de panneau (grand)',
      prices: {
        SIMPLE: 150
      },
      multiple: true,
      id: '11.bag-cure-6'
    }, {
      name: 'Déchirure : réparation avec changement de panneau (complex)',
      prices: {
        SIMPLE: 180
      },
      multiple: true,
      id: '11.bag-cure-7'
    }, {
      name: 'Attache de sangle - Changement simple (x1)',
      prices: {
        SIMPLE: 30
      },
      id: '11.bag-cure-8'
    }, {
      name: 'Attache de sangle - Changement standard (x1)',
      prices: {
        SIMPLE: 40
      },
      id: '11.bag-cure-9'
    }, {
      name: 'Attache de sangle - Changement complexe (x1)',
      prices: {
        SIMPLE: 50
      },
      id: '11.bag-cure-10'
    }, {
      name: 'Bandoulière / anse / poignée / biais - Changement simple (x1)',
      prices: {
        SIMPLE: 40
      },
      id: '11.bag-cure-11'
    }, {
      name: 'Bandoulière / anse / poignée / biais - Changement standard (x1)',
      prices: {
        SIMPLE: 70
      },
      id: '11.bag-cure-12'
    }, {
      name: 'Bandoulière / anse / poignée / biais - Changement complexe (x1)',
      prices: {
        SIMPLE: 100
      },
      id: '11.bag-cure-13'
    }, {
      name: 'Doublure - Changement partiel',
      prices: {
        SIMPLE: 45
      },
      id: '11.bag-cure-14'
    }, {
      name: 'Doublure - Changement intégral - Simple',
      prices: {
        SIMPLE: 80
      },
      id: '11.bag-cure-15'
    }, {
      name: 'Doublure - Changement intégral - Standard',
      prices: {
        SIMPLE: 120
      },
      id: '11.bag-cure-16'
    }, {
      name: 'Doublure - Changement intégral - Complexe',
      prices: {
        SIMPLE: 160
      },
      id: '11.bag-cure-17'
    }, {
      name: 'Renfort intérieur - Changement simple (x1 empiècement) ',
      prices: {
        SIMPLE: 30
      },
      id: '11.bag-cure-18'
    }, {
      name: 'Renfort intérieur - Changement complexe (x1 empiècement) ',
      prices: {
        SIMPLE: 50
      },
      id: '11.bag-cure-19'
    }, {
      name: 'Bandoulière / anse / poignée - Changement métallique (x1)',
      prices: {
        SIMPLE: 40
      },
      id: '11.bag-cure-20'
    }, {
      name: 'Zip - Changement simple',
      prices: {
        SIMPLE: 60
      },
      multiple: true,
      id: '11.bag-cure-21'
    }, {
      name: 'Zip - Changement simple fourni par le client',
      prices: {
        SIMPLE: 50
      },
      multiple: true,
      id: '11.bag-cure-22'
    }, {
      name: 'Zip - Changement standard',
      prices: {
        SIMPLE: 80
      },
      multiple: true,
      id: '11.bag-cure-23'
    }, {
      name: 'Zip - Changement standard fourni par le client',
      prices: {
        SIMPLE: 70
      },
      multiple: true,
      id: '11.bag-cure-24'
    }, {
      name: 'Zip - Changement complexe',
      prices: {
        SIMPLE: 100
      },
      multiple: true,
      id: '11.bag-cure-25'
    }, {
      name: 'Zip - Changement complexe fourni par le client',
      prices: {
        SIMPLE: 90
      },
      multiple: true,
      id: '11.bag-cure-26'
    }, {
      name: 'Curseur',
      prices: {
        SIMPLE: 15
      },
      id: '11.bag-cure-27'
    }, {
      name: 'Curseur fourni par le client',
      prices: {
        SIMPLE: 13
      },
      id: '11.bag-cure-28'
    }, {
      name: 'Tirette de curseur',
      prices: {
        SIMPLE: 5
      },
      id: '11.bag-cure-29'
    }, {
      name: 'Tirette de curseur fourni par le client',
      prices: {
        SIMPLE: 4
      },
      id: '11.bag-cure-30'
    }, {
      name: 'Boutons pression / rivet / oeillet',
      prices: {
        SIMPLE: 5
      },
      multiple: true,
      id: '11.bag-cure-31'
    }, {
      name: 'Boutons pression / rivet / oeillet fourni par le client',
      prices: {
        SIMPLE: 4
      },
      multiple: true,
      id: '11.bag-cure-32'
    }, {
      name: 'Fermoir - Changement simple',
      prices: {
        SIMPLE: 30
      },
      id: '11.bag-cure-33'
    }, {
      name: 'Fermoir - Changement simple fourni par le client',
      prices: {
        SIMPLE: 20
      },
      id: '11.bag-cure-34'
    }, {
      name: 'Fermoir - Changement complexe',
      prices: {
        SIMPLE: 50
      },
      id: '11.bag-cure-35'
    }, {
      name: 'Fermoir - Changement complexe fourni par le client',
      prices: {
        SIMPLE: 40
      },
      id: '11.bag-cure-36'
    }, {
      name: 'Crochet / boucle / autre pièce métallique - Changement',
      prices: {
        SIMPLE: 30
      },
      multiple: true,
      id: '11.bag-cure-37'
    }, {
      name: 'Crochet / boucle / autre pièce métallique fourni par le client - Changement',
      prices: {
        SIMPLE: 20
      },
      multiple: true,
      id: '11.bag-cure-38'
    }, {
      name: 'Couture décousu',
      prices: {
        SIMPLE: 20
      },
      id: '11.bag-cure-39'
    }]
  }, communLeatherGoodsFinish('bag')]
}, _objectSpread({
  name: 'Portefeuille',
  slug: 'wallet',
  hasMostCommonCategory: false,
  showInPlugin: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }]
}, generateLeatherGoodsAccePrice('wallet')), _objectSpread({
  name: 'Ceinture',
  slug: 'belt',
  hasMostCommonCategory: false,
  showInPlugin: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }]
}, generateLeatherGoodsAccePrice('belt')), {
  name: 'Chaussures',
  slug: 'shoes',
  hasMostCommonCategory: false,
  showInPlugin: false,
  types: [{
    slug: 'SIMPLE',
    name: 'Cuir'
  }, {
    slug: 'COMPLEX',
    name: 'Daim'
  }],
  categories: [{
    name: 'Entretenir',
    items: [{
      name: 'Entretien (nettoyage & cirage)',
      prices: {
        SIMPLE: 25,
        COMPLEX: 29
      },
      id: '11.shoes-prevent-1'
    }, {
      name: 'Entretien (nettoyage & cirage) - Bottes',
      prices: {
        SIMPLE: 35,
        COMPLEX: 39
      },
      id: '11.shoes-prevent-2'
    },
    // Same price textile, leather, suede
    {
      name: 'Entretien (nettoyage & cirage) - Sneakers',
      prices: {
        SIMPLE: 35,
        COMPLEX: 35
      },
      id: '11.shoes-prevent-3'
    }, {
      name: 'Cirage & Glaçage',
      prices: {
        SIMPLE: 55,
        COMPLEX: 55
      },
      id: '11.shoes-prevent-4'
    }, {
      name: 'Rénovation complète',
      prices: {
        SIMPLE: 55,
        COMPLEX: 59
      },
      id: '11.shoes-prevent-5'
    }, {
      name: 'Rénovation complète - Sneakers',
      prices: {
        SIMPLE: 55,
        COMPLEX: 55
      },
      id: '11.shoes-prevent-6'
    }, {
      name: 'Rénovation complète - Bottes',
      prices: {
        SIMPLE: 65,
        COMPLEX: 65
      },
      id: '11.shoes-prevent-7'
    }, {
      name: 'Mise en forme - Largeur',
      prices: {
        SIMPLE: 15,
        COMPLEX: 15
      },
      id: '11.shoes-prevent-8'
    }, {
      name: 'Mise en forme - Coup de pied',
      prices: {
        SIMPLE: 29,
        COMPLEX: 29
      },
      id: '11.shoes-prevent-9'
    }, {
      name: 'Mise en forme - Mollet (bottine ou botte)',
      prices: {
        SIMPLE: 29,
        COMPLEX: 29
      },
      id: '11.shoes-prevent-10'
    }, {
      name: 'Pose de patins (x2)',
      prices: {
        SIMPLE: 26,
        COMPLEX: 26
      },
      id: '11.shoes-prevent-11'
    }, {
      name: 'Pose de fers (x2)',
      prices: {
        SIMPLE: 21,
        COMPLEX: 21
      },
      id: '11.shoes-prevent-12'
    }, {
      name: 'Protection complète - Patins & fers (x2)',
      prices: {
        SIMPLE: 45,
        COMPLEX: 45
      },
      id: '11.shoes-prevent-13'
    }]
  }, {
    name: 'Réparer',
    items: [{
      name: 'Ressemelage - Caoutchouc',
      prices: {
        SIMPLE: 80
      },
      id: '11.shoes-cure-1'
    }, {
      name: 'Ressemelage - Collé Cuir',
      prices: {
        SIMPLE: 90
      },
      id: '11.shoes-cure-2'
    }, {
      name: 'Ressemelage - Sneakers',
      prices: {
        SIMPLE: 70
      },
      id: '11.shoes-cure-3'
    }, {
      name: 'Ressemelage - Cousu rainette',
      prices: {
        SIMPLE: 145
      },
      id: '11.shoes-cure-4'
    }, {
      name: 'Ressemelage - Cousu sous gravure',
      prices: {
        SIMPLE: 175
      },
      id: '11.shoes-cure-5'
    }, {
      name: 'Ressemelage - Birkenstock',
      prices: {
        SIMPLE: 54
      },
      id: '11.shoes-cure-6'
    }, {
      name: 'Bonbout (changement) - Chaussures à talon plat - Caoutchouc',
      prices: {
        SIMPLE: 24
      },
      id: '11.shoes-cure-7'
    }, {
      name: 'Bonbout (changement) - Chaussures à talon plat - Cuir + caoutchouc',
      prices: {
        SIMPLE: 24
      },
      id: '11.shoes-cure-8'
    }, {
      name: 'Bonbout (changement) - Talons aiguille',
      prices: {
        SIMPLE: 15
      },
      id: '11.shoes-cure-9'
    }, {
      name: 'Talon complet (changement) - Chaussures plates',
      prices: {
        SIMPLE: 65
      },
      id: '11.shoes-cure-10'
    }, {
      name: 'Enveloppe talon (changement) - Chaussures à talons',
      prices: {
        SIMPLE: 55
      },
      id: '11.shoes-cure-11'
    }, {
      name: 'Redresse talon - Chaussures plates',
      prices: {
        SIMPLE: 17
      },
      id: '11.shoes-cure-12'
    }, {
      name: 'Semelle intérieure - Demi',
      prices: {
        SIMPLE: 17
      },
      id: '11.shoes-cure-13'
    }, {
      name: 'Semelle intérieure - Complète',
      prices: {
        SIMPLE: 22
      },
      id: '11.shoes-cure-14'
    }, {
      name: 'Glissoirs (changement)',
      prices: {
        SIMPLE: 38
      },
      id: '11.shoes-cure-15'
    }, {
      name: 'Glissoirs boots (changement)',
      prices: {
        SIMPLE: 58
      },
      id: '11.shoes-cure-16'
    }, {
      name: 'Zip - Changement (x1)',
      prices: {
        SIMPLE: 45
      },
      multiple: true,
      id: '11.shoes-cure-17'
    }, {
      name: 'Zip de bottes - Changement (x1)',
      prices: {
        SIMPLE: 55
      },
      multiple: true,
      id: '11.shoes-cure-18'
    }, {
      name: 'Boutons pression / œillets / rivets (x1)',
      prices: {
        SIMPLE: 11
      },
      multiple: true,
      id: '11.shoes-cure-19'
    }, {
      name: 'Boucle - Changement (x1)',
      prices: {
        SIMPLE: 19
      },
      multiple: true,
      id: '11.shoes-cure-20'
    }, {
      name: 'Élastique / scratch - Changement (x1)',
      prices: {
        SIMPLE: 19
      },
      multiple: true,
      id: '11.shoes-cure-21'
    }, {
      name: 'Boucle avec élastique - Changement (x1)',
      prices: {
        SIMPLE: 35
      },
      multiple: true,
      id: '11.shoes-cure-22'
    }]
  }, {
    name: 'Finition',
    items: [{
      name: 'Couture / Finition supplémentaire - Simple',
      prices: {
        SIMPLE: 5
      },
      id: '11.shoes-finish-1'
    }, {
      name: 'Couture / Finition supplémentaire - Standard',
      prices: {
        SIMPLE: 10
      },
      id: '11.shoes-finish-2'
    }, {
      name: 'Couture / Finition supplémentaire - Complexe',
      prices: {
        SIMPLE: 20
      },
      id: '11.shoes-finish-3'
    }]
  }]
}];
var _default = exports["default"] = rawLeatherGoodsPricing;